import React from 'react';

import { Button } from '@material-ui/core';

import InputField from '../../common/components/inputField';
import classes from '../../css/getCSS';


const loginForm = (props) => {
  return (
    <React.Fragment>
      <InputField
        id="new_password1"
        config={props.inputs.new_password1}
        changed={event => props.inputChangedHandler(event, 'new_password1')}
      />
      <br />
      <InputField
        id="new_password2"
        config={props.inputs.new_password2}
        changed={event => props.inputChangedHandler(event, 'new_password2')}
      />
      <br />
      <Button variant="contained" color="primary" type="submit" size="large" className={classes.Button}>
        Submit
      </Button>
    </React.Fragment>
  );
};

export default loginForm;



// WEBPACK FOOTER //
// ./src/auth/components/SetPasswordForm.js